import { useFlag } from '@unleash/proxy-client-react';
import { Outlet } from 'react-router-dom';
import { WaitingRoom } from '../../pages/WaitingRoom';

export function DtiOpuGuard() {
  const hideSalesFlag = useFlag('hide-sales');
  return !hideSalesFlag ? <Outlet /> : <WaitingRoom />;
}
